import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BoobleModalService } from 'booble-modal';

import { OrdersService } from 'src/app/shared/services/orders.service';

import { NotifierService } from 'angular-notifier';
import { InboundOrderDto } from 'src/app/domain/models/dto/inbound-order.dto';
import { GenerateInvoiceSuccessModalComponent } from '../generate-invoice-success-modal/generate-invoice-success-modal.component';
import { DomSanitizer } from '@angular/platform-browser';
import { FileHandle } from 'src/app/shared/directives/file-drop.directive';
import { MatIconRegistry } from '@angular/material/icon';

@Component({
  selector: 'app-send-documents-modal',
  templateUrl: './send-documents-modal.component.html',
  styleUrls: ['./send-documents-modal.component.scss'],
})
export class SendDocumentsModalComponent implements OnInit {
  sendButton = false;
  boobleModalData: InboundOrderDto;
  selectedFiles: FileHandle[] = [];
  loading: boolean;

  private readonly notifier: NotifierService;

  constructor(
    private readonly router: Router,
    notifierService: NotifierService,
    private matIconRegistry: MatIconRegistry,
    private domSanitzer: DomSanitizer,
    private readonly route: ActivatedRoute,
    private modalService: BoobleModalService,
    private readonly ordersService: OrdersService
  ) {
    this.notifier = notifierService;
    this.matIconRegistry.addSvgIcon(
      'cloud-upload',
      this.domSanitzer.bypassSecurityTrustResourceUrl(
        'assets/icons/cloud-upload.svg'
      )
    );

    this.matIconRegistry.addSvgIcon(
      'file',
      this.domSanitzer.bypassSecurityTrustResourceUrl(
        'assets/image/document-icon.svg'
      )
    );
  }

  ngOnInit() {}

  closeModal() {
    this.modalService.dismiss(null);
  }

  filesDropped(files: FileHandle[]): void {
    this.selectedFiles = files;
  }

  selectFile(event: any) {
    this.selectedFiles.push({
      file: event.target.files[0],
      url: this.domSanitzer.bypassSecurityTrustUrl(
        window.URL.createObjectURL(event.target.files[0])
      ),
    });
  }

  removeFile(index: number): void {
    this.selectedFiles.splice(index, 1);
  }

  openGenerateSuccessModal() {
    this.loading = true;

    this.ordersService
      .uploadInvoiceFileOutbound(
        this.boobleModalData.id,
        this.selectedFiles,
        this.boobleModalData.numeroDI,
        this.boobleModalData.protocoloDI
      )
      .subscribe((uploadResult) => {
        this.sendButton = false;
        this.loading = false;
        this.modalService.dismiss(null);
       this.notifier.notify('success', 'Documentação enviada com sucesso!')
        this.ordersService.updateOrderView();
      });
  }
}
